module.exports = __webpack_public_path__ + "static/media/clock-2.743831c1.svg";